import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import taskService from '../../services/taskService';
import projectService from '../../services/projectService';
import milestoneService from '../../services/milestoneService';
import { FiUpload, FiX, FiFile } from 'react-icons/fi';
import VendorStore from './VendorStore';
import vendorDashboardService from '../../services/vendorDashboardService';
import { toast } from 'react-toastify';
import ContractStore from './ContractStore';

const TABS = [
    { id: 'details', label: 'Contract Details' },
    { id: 'attachments', label: 'Attachments' },
];

const UserVendorCreateContract = ({ isEdit = false }) => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState('details');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [projects, setProjects] = useState([]);
    const [milestones, setMilestones] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [users, setUsers] = useState([]);
    const [attachments, setAttachments] = useState([]);
    const [dragOver, setDragOver] = useState(false);
    const [pendingFile, setPendingFile] = useState(null);
    const [uploadProgress, setUploadProgress] = useState(0);

    const [formData, setFormData] = useState({
        contract_name: '',
        contract_type: '',
        description: '',
        status: '',
        start_date: '',
        end_date: '',
        renewal_date: '',
        auto_renewal: '',
        renewal_notice_days: '',
        contract_value: '',
        currency: '',
        payment_terms: '',
        payment_schedule: '',
        terms_and_conditions: '',
        deliverables: '',
        sla_terms: '',
        penalties: '',
        notes: '',
    });

    const { selectedVendor, setSelectedVendor, clearSelectedVendor } = VendorStore();

    const { selectedContract, setSelectedContract, clearSelectedContract } = ContractStore();

    useEffect(() => {
        // fetchProjects();
        // fetchMilestones();
        // fetchTasks();
        // loadUsers();
        console.log("selected vendors", selectedContract)

        if (isEdit && id) {
            console.log("idddd===", id)
            fetchContract();
        }

        // if (selectedIssue) {
        //   fetchIssue();
        // }

    }, [isEdit, id, selectedVendor, selectedContract]);

    const formatDate = (timestamp) => {
        const date = new Date(timestamp);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);

        if (date.toDateString() === today.toDateString()) {
            return 'Today';
        } else if (date.toDateString() === yesterday.toDateString()) {
            return 'Yesterday';
        } else {
            return date.toLocaleDateString('en-US', {
                month: 'short',
                day: 'numeric',
                year: date.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
            });
        }
    };

    const fetchContract = () => {

        try {
            setLoading(true);
            setFormData({
                contract_name: selectedContract.contract_name || '',
                contract_type: selectedContract.contract_type || '',
                description: selectedContract.description || '',
                status: selectedContract.status || '',
                start_date: selectedContract.start_date ? selectedContract.start_date.split('T')[0] : '',
                end_date: selectedContract.end_date ? selectedContract.end_date.split('T')[0] : '',
                renewal_date: selectedContract.renewal_date ? selectedContract.renewal_date.split('T')[0] : '',
                auto_renewal: selectedContract.auto_renewal || '',
                renewal_notice_days: selectedContract.renewal_notice_days || '',
                contract_value: selectedContract.contract_value || '',
                currency: selectedContract.currency || '',
                payment_terms: selectedContract.payment_terms || '',
                payment_schedule: selectedContract.payment_schedule || '',
                terms_and_conditions: selectedContract.terms_and_conditions || '',
                deliverables: selectedContract.deliverables || '',
                sla_terms: selectedContract.sla_terms || '',
                penalties: selectedContract.penalties || '',
                notes: selectedContract.notes || '',
            });
        } catch (err) {
            setError(err.response?.data?.error || 'Failed to fetch task');
        } finally {
            setLoading(false);
        }

    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value
        }));
    };

    const contract = [
        {
            "key": "Service Agreement",
            "value": "Service Agreement"
        },
        {
            "key": "Statement of Work",
            "value": "Statement of Work"
        },
        {
            "key": "Purchase Order",
            "value": "Purchase Order"
        },
        {
            "key": "NDA",
            "value": "NDA"
        },
        {
            "key": "Consulting",
            "value": "Consulting"
        },
        {
            "key": "Subscription",
            "value": "Subscription"
        },
        {
            "key": "Other",
            "value": "Other"
        }
    ]

    const status = [
        { "key": "Draft", "value": "Draft" },
        { "key": "Under Review", "value": "Under Review" },
        { "key": "Approved", "value": "Approved" },
        { "key": "Active", "value": "Active" },
        { "key": "Expired", "value": "Expired" },
        { "key": "Terminated", "value": "Terminated" },
        { "key": "Renewed", "value": "Renewed" }
    ]

    const payment = [
        { key: "One Time", value: "One time" },
        { key: "Monthly", value: "Monthly" },
        { key: "Quarterly", value: "Quarterly" },
        { key: "Annually", value: "Annually" },
        { key: "Milestone-based", value: "Milestone-based" },
        { key: "Custom", value: "Custom" }
    ];





    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const submitData = {
                ...formData,
                id:selectedContract?.id
            };

            if (isEdit) {
                 await vendorDashboardService.updateContract(selectedVendor.id,selectedContract.id, submitData);
            } else {
                await vendorDashboardService.createContract(selectedVendor.id, submitData);
            }

            toast.success('Created successful!');

            navigate(`/app/vendors/${selectedVendor.id}/contracts`);
        } catch (err) {
            toast.error(err.response?.data?.error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => navigate('/app/vendors');

    const handleFileSelect = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) setPendingFile(files[0]);
        simulateUpload(files);
    };

    const simulateUpload = async (files) => {
        for (let i = 0; i <= 100; i += 10) {
            setUploadProgress(i);
            await new Promise(resolve => setTimeout(resolve, 100));
        }
        addFiles(files);
        setPendingFile(null);
        setUploadProgress(0);
    };

    const addFiles = (files) => {
        const newAttachments = files.map(file => ({
            id: Date.now() + Math.random(),
            name: file.name,
            size: file.size,
            type: file.type,
            file,
            uploadedAt: new Date().toLocaleString(),
        }));
        setAttachments(prev => [...prev, ...newAttachments]);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragOver(false);
        const files = Array.from(e.dataTransfer.files);
        if (files.length > 0) setPendingFile(files[0]);
        simulateUpload(files);
    };
    const removeAttachment = (attachId) => {
        setAttachments(prev => prev.filter(a => a.id !== attachId));
    };

    const formatBytes = (bytes) => {
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    };

    const getFileIcon = (type) => {
        if (type.startsWith('image/'));
        if (type === 'application/pdf');
        if (type.includes('word'));
        if (type.includes('excel') || type.includes('spreadsheet'));
        if (type.includes('zip') || type.includes('rar'));
        return <FiFile size={24} style={{ color: 'var(--color-text-secondary, #9ca3af)' }} />;
    };

    if (loading && isEdit) {
        return <div className="loading">Loading task...</div>;
    }

    return (
        <div className="task-form-container">
            <div className="task-form-header">
                <h1>{isEdit ? 'Edit Contract' : 'Create New Contract'}</h1>
            </div>

            <div className="tf-tab-bar">
                {TABS.map(tab => (
                    <button
                        key={tab.id}
                        type="button"
                        className={`tf-tab ${activeTab === tab.id ? 'tf-tab--active' : ''}`}
                        onClick={() => setActiveTab(tab.id)}
                    >
                        <span className="tf-tab-icon">{tab.icon}</span>
                        {tab.label}
                    </button>
                ))}
            </div>

            {error && <div className="alert alert-danger">{error}</div>}


            {activeTab === 'details' && (
                <form onSubmit={handleSubmit} style={{ padding: 0 }}>
                    {error && <div className="alert alert-danger">{error}</div>}

                    <div className="form-section review-section">
                        <h3>Vendor Details</h3>
                        <div className="review-grid">
                            <div className="review-card">
                                <h4><i className="fas fa-building"></i>Basic Information</h4>
                                <span className="vendor-code">
                                    {selectedVendor.vendor_code}
                                </span>
                                <p><strong>Company:</strong> {selectedVendor.company_name}</p>
                                <p><strong>Type:</strong> {selectedVendor.vendor_type}</p>
                                <p><strong>Category:</strong> {selectedVendor.category}</p>
                            </div>
                            <div className="review-card">
                                <h4><i className="fas fa-address-card"></i> Contact Details</h4>
                                <p><strong>Email:</strong> {selectedVendor.email}</p>
                                <p><strong>Phone:</strong> {selectedVendor.phone}</p>
                                <p><strong>Address:</strong> {selectedVendor.address}</p>
                            </div>

                        </div>
                    </div>

                    <div className="form-section p-0 " style={{ borderRadius: 0 }}>
                        <h3>Contract Information</h3>

                        <div className=" mb-5">
                            <div className="form-group">
                                <label htmlFor="contract_name">Contract Name</label>
                                <input
                                    type="contract_name"
                                    id="contract_name"
                                    name="contract_name"
                                    value={formData.contract_name}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    placeholder="Enter contract name"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="contract_type">Contract Type </label>
                                <select
                                    id="contract_type"
                                    name="contract_type"
                                    value={formData.contract_type}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                >
                                    <option value="">Select Contract Type</option>
                                    {contract.map((c) => (
                                        <option key={c.key} value={c.key}>
                                            {c.value}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="status">Status *</label>
                                <select
                                    id="status"
                                    name="status"
                                    value={formData.status}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                >
                                    <option value="">Select Status</option>
                                    {status.map((s) => (
                                        <option key={s.key} value={s.key}>
                                            {s.value}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="renewal_notice_days">Renewal notice days</label>
                                <input
                                    type="number"
                                    id="renewal_notice_days"
                                    name="renewal_notice_days"
                                    value={formData.renewal_notice_days}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    placeholder="Enter contract name"
                                />
                            </div>


                            <div className="form-group ">
                                <label htmlFor="start_date">Start Date</label>
                                <input
                                    type="date"
                                    id="start_date"
                                    name="start_date"
                                    value={formData.start_date}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group ">
                                <label htmlFor="end_date">End Date</label>
                                <input
                                    type="date"
                                    id="end_date"
                                    name="end_date"
                                    value={formData.end_date}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group ">
                                <label htmlFor="renewal_date">Renewal Date</label>
                                <input
                                    type="date"
                                    id="renewal_date"
                                    name="renewal_date"
                                    value={formData.renewal_date}
                                    onChange={handleChange}
                                    className="form-control"
                                />
                            </div>

                        </div>

                        <div className="checkbox-group w-1/3">
                            <label>
                                <input
                                    type="checkbox"
                                    name="auto_renewal"
                                    checked={formData.auto_renewal}
                                    onChange={handleChange}
                                />
                                <span>Auto Renewal</span>
                            </label>
                        </div>

                        <div className=" mb-5">
                            <div className="form-group ">
                                <label htmlFor="description">Description</label>
                                <textarea
                                    id="description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter task description"
                                />
                            </div>
                        </div>

                    </div>

                    <div className="form-section ">
                        <h3>Contract Values</h3>

                        <div className=" mb-5">
                            <div className="form-group">
                                <label htmlFor="contract_value">Contract Values</label>
                                <input
                                    type="contract_value"
                                    id="contract_value"
                                    name="contract_value"
                                    value={formData.contract_value}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                    placeholder="Enter contract value"
                                />
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
                            <div className="form-group">
                                <label htmlFor="currency ">Currency</label>
                                <select
                                    id="currency"
                                    name="currency"
                                    value={formData.currency}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                >
                                    <option value="">Select option</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                    <option value="GBP">GBP</option>
                                    <option value="INR">INR</option>
                                    <option value="CAD">CAD</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="payment_terms"></label>Payment Terms
                                <select
                                    id="payment_terms"
                                    name="payment_terms"
                                    value={formData.payment_terms}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                >
                                    <option value="Net 15">Net 15</option>
                                    <option value="Net 30">Net 30</option>
                                    <option value="Net 45">Net 45</option>
                                    <option value="Net 60">Net 60</option>
                                    <option value="Due on Receipt">Due on Receipt</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label htmlFor="payment_schedule"></label>Payment Schedule
                                <select
                                    id="payment_schedule"
                                    name="payment_schedule"
                                    value={formData.payment_schedule}
                                    onChange={handleChange}
                                    className="form-control"
                                    required
                                >
                                    <option value="">Select Payment Schedule</option>
                                    {payment.map((p) => (
                                        <option key={p.key} value={p.key}>
                                            {p.value}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                    </div>

                    <div className="form-section ">
                        <h3>Additional Details</h3>
                        <div className=" mb-5">
                            <div className="form-group ">
                                <label htmlFor="terms_and_conditions">Terms Conditions </label>
                                <textarea
                                    id="terms_and_conditions"
                                    name="terms_and_conditions"
                                    value={formData.terms_and_conditions}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter terms"
                                />
                            </div>
                        </div>
                        <div className=" mb-5">
                            <div className="form-group ">
                                <label htmlFor="deliverables">Deliverables</label>
                                <textarea
                                    id="deliverables"
                                    name="deliverables"
                                    value={formData.deliverables}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter delivarables"
                                />
                            </div>
                        </div>

                        <div className=" mb-5">
                            <div className="form-group ">
                                <label htmlFor="sla_terms">SLA Terms </label>
                                <textarea
                                    id="sla_terms"
                                    name="sla_terms"
                                    value={formData.sla_terms}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter sla terms"
                                />
                            </div>
                        </div>
                        <div className=" mb-5">
                            <div className="form-group ">
                                <label htmlFor="penalties">Penalties</label>
                                <textarea
                                    id="penalties"
                                    name="penalties"
                                    value={formData.penalties}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter penalties "
                                />
                            </div>
                        </div>
                        <div className=" mb-5">
                            <div className="form-group ">
                                <label htmlFor="notes">notes</label>
                                <textarea
                                    id="notes"
                                    name="notes"
                                    value={formData.notes}
                                    onChange={handleChange}
                                    className="form-control"
                                    rows="4"
                                    placeholder="Enter notes"
                                />
                            </div>
                        </div>
                    </div>



                    <div className="form-actions">
                        <button
                            type="button"
                            onClick={handleCancel}
                            className="btn btn-secondary"
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={loading}
                        >
                            {loading ? 'Saving...' : (isEdit ? 'Update Contract' : 'Create Contract')}
                        </button>
                    </div>
                </form>
            )}
            {activeTab === 'attachments' && (
                <div>
                    <div className="tf-tab-panel tf-attachments-panel">

                        <div
                            className={`tf-dropzone ${dragOver ? 'tf-dropzone--active' : ''}`}
                            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                            onDragLeave={() => setDragOver(false)}
                            onDrop={handleDrop}
                        >
                            <input
                                type="file"
                                multiple
                                onChange={handleFileSelect}
                                style={{ display: 'none' }}
                                id="file-upload"
                            />
                            <label htmlFor="file-upload" style={{ cursor: 'pointer', display: 'block', textAlign: 'center', padding: '2rem 1rem' }}>
                                {pendingFile ? (
                                    <>
                                        <FiFile size={48} style={{ color: 'var(--color-primary, #2563eb)', marginBottom: '0.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 600, fontSize: '0.95rem' }}>
                                            {pendingFile.name}
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            {formatBytes(pendingFile.size)}
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <FiUpload size={48} style={{ color: 'var(--color-text-secondary, #9ca3af)', marginBottom: '0.5rem', marginLeft: '4.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 500 }}>
                                            Click to upload or drag and drop
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            Maximum file size: 50 MB
                                        </p>
                                    </>
                                )}
                            </label>
                        </div>

                        {/* Upload Progress */}
                        {uploadProgress > 0 && uploadProgress < 100 && (
                            <div style={{ marginTop: '1rem' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: 'var(--color-text-secondary)', marginBottom: '0.25rem' }}>
                                    <span>Uploading...</span>
                                    <span>{uploadProgress}%</span>
                                </div>
                                <div style={{ width: '100%', background: 'var(--color-border, #e5e7eb)', borderRadius: '9999px', height: '8px' }}>
                                    <div
                                        style={{
                                            width: `${uploadProgress}%`,
                                            height: '8px',
                                            borderRadius: '9999px',
                                            background: 'var(--color-primary, #2563eb)',
                                            transition: 'width 0.3s ease',
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        {/* Attachment list */}
                        {attachments.length > 0 ? (
                            <ul className="tf-attachment-list">
                                {attachments.map((attachment) => (
                                    <li key={attachment.id} className="tf-attachment-item">
                                        <span className="tf-attachment-file-icon">
                                            {getFileIcon(attachment.type)}
                                        </span>
                                        <div className="tf-attachment-info">
                                            <span className="tf-attachment-name">{attachment.name}</span>
                                            <span className="tf-attachment-meta">
                                                {formatBytes(attachment.size)} · {attachment.uploadedAt}
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            className="tf-attachment-remove"
                                            onClick={() => removeAttachment(attachment.id)}
                                            aria-label={`Remove ${attachment.name}`}
                                        >
                                            <FiX size={14} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="tf-empty-msg">No attachments yet.</p>
                        )}

                    </div>
                    <div className="tf-tab-panel tf-attachments-panel">

                        <div
                            className={`tf-dropzone ${dragOver ? 'tf-dropzone--active' : ''}`}
                            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                            onDragLeave={() => setDragOver(false)}
                            onDrop={handleDrop}
                        >
                            <input
                                type="file"
                                multiple
                                onChange={handleFileSelect}
                                style={{ display: 'none' }}
                                id="file-upload"
                            />
                            <label htmlFor="file-upload" style={{ cursor: 'pointer', display: 'block', textAlign: 'center', padding: '2rem 1rem' }}>
                                {pendingFile ? (
                                    <>
                                        <FiFile size={48} style={{ color: 'var(--color-primary, #2563eb)', marginBottom: '0.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 600, fontSize: '0.95rem' }}>
                                            {pendingFile.name}
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            {formatBytes(pendingFile.size)}
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <FiUpload size={48} style={{ color: 'var(--color-text-secondary, #9ca3af)', marginBottom: '0.5rem', marginLeft: '4.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 500 }}>
                                            Click to upload or drag and drop
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            Maximum file size: 50 MB
                                        </p>
                                    </>
                                )}
                            </label>
                        </div>

                        {/* Upload Progress */}
                        {uploadProgress > 0 && uploadProgress < 100 && (
                            <div style={{ marginTop: '1rem' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: 'var(--color-text-secondary)', marginBottom: '0.25rem' }}>
                                    <span>Uploading...</span>
                                    <span>{uploadProgress}%</span>
                                </div>
                                <div style={{ width: '100%', background: 'var(--color-border, #e5e7eb)', borderRadius: '9999px', height: '8px' }}>
                                    <div
                                        style={{
                                            width: `${uploadProgress}%`,
                                            height: '8px',
                                            borderRadius: '9999px',
                                            background: 'var(--color-primary, #2563eb)',
                                            transition: 'width 0.3s ease',
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        {/* Attachment list */}
                        {attachments.length > 0 ? (
                            <ul className="tf-attachment-list">
                                {attachments.map((attachment) => (
                                    <li key={attachment.id} className="tf-attachment-item">
                                        <span className="tf-attachment-file-icon">
                                            {getFileIcon(attachment.type)}
                                        </span>
                                        <div className="tf-attachment-info">
                                            <span className="tf-attachment-name">{attachment.name}</span>
                                            <span className="tf-attachment-meta">
                                                {formatBytes(attachment.size)} · {attachment.uploadedAt}
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            className="tf-attachment-remove"
                                            onClick={() => removeAttachment(attachment.id)}
                                            aria-label={`Remove ${attachment.name}`}
                                        >
                                            <FiX size={14} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="tf-empty-msg">No attachments yet.</p>
                        )}

                    </div>
                    <div className="tf-tab-panel tf-attachments-panel">

                        <div
                            className={`tf-dropzone ${dragOver ? 'tf-dropzone--active' : ''}`}
                            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                            onDragLeave={() => setDragOver(false)}
                            onDrop={handleDrop}
                        >
                            <input
                                type="file"
                                multiple
                                onChange={handleFileSelect}
                                style={{ display: 'none' }}
                                id="file-upload"
                            />
                            <label htmlFor="file-upload" style={{ cursor: 'pointer', display: 'block', textAlign: 'center', padding: '2rem 1rem' }}>
                                {pendingFile ? (
                                    <>
                                        <FiFile size={48} style={{ color: 'var(--color-primary, #2563eb)', marginBottom: '0.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 600, fontSize: '0.95rem' }}>
                                            {pendingFile.name}
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            {formatBytes(pendingFile.size)}
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <FiUpload size={48} style={{ color: 'var(--color-text-secondary, #9ca3af)', marginBottom: '0.5rem', marginLeft: '4.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 500 }}>
                                            Click to upload or drag and drop
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            Maximum file size: 50 MB
                                        </p>
                                    </>
                                )}
                            </label>
                        </div>

                        {/* Upload Progress */}
                        {uploadProgress > 0 && uploadProgress < 100 && (
                            <div style={{ marginTop: '1rem' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: 'var(--color-text-secondary)', marginBottom: '0.25rem' }}>
                                    <span>Uploading...</span>
                                    <span>{uploadProgress}%</span>
                                </div>
                                <div style={{ width: '100%', background: 'var(--color-border, #e5e7eb)', borderRadius: '9999px', height: '8px' }}>
                                    <div
                                        style={{
                                            width: `${uploadProgress}%`,
                                            height: '8px',
                                            borderRadius: '9999px',
                                            background: 'var(--color-primary, #2563eb)',
                                            transition: 'width 0.3s ease',
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        {/* Attachment list */}
                        {attachments.length > 0 ? (
                            <ul className="tf-attachment-list">
                                {attachments.map((attachment) => (
                                    <li key={attachment.id} className="tf-attachment-item">
                                        <span className="tf-attachment-file-icon">
                                            {getFileIcon(attachment.type)}
                                        </span>
                                        <div className="tf-attachment-info">
                                            <span className="tf-attachment-name">{attachment.name}</span>
                                            <span className="tf-attachment-meta">
                                                {formatBytes(attachment.size)} · {attachment.uploadedAt}
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            className="tf-attachment-remove"
                                            onClick={() => removeAttachment(attachment.id)}
                                            aria-label={`Remove ${attachment.name}`}
                                        >
                                            <FiX size={14} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="tf-empty-msg">No attachments yet.</p>
                        )}

                    </div>
                    <div className="tf-tab-panel tf-attachments-panel">

                        <div
                            className={`tf-dropzone ${dragOver ? 'tf-dropzone--active' : ''}`}
                            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                            onDragLeave={() => setDragOver(false)}
                            onDrop={handleDrop}
                        >
                            <input
                                type="file"
                                multiple
                                onChange={handleFileSelect}
                                style={{ display: 'none' }}
                                id="file-upload"
                            />
                            <label htmlFor="file-upload" style={{ cursor: 'pointer', display: 'block', textAlign: 'center', padding: '2rem 1rem' }}>
                                {pendingFile ? (
                                    <>
                                        <FiFile size={48} style={{ color: 'var(--color-primary, #2563eb)', marginBottom: '0.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 600, fontSize: '0.95rem' }}>
                                            {pendingFile.name}
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            {formatBytes(pendingFile.size)}
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <FiUpload size={48} style={{ color: 'var(--color-text-secondary, #9ca3af)', marginBottom: '0.5rem', marginLeft: '4.5rem' }} />
                                        <p style={{ margin: '0 0 0.25rem', fontWeight: 500 }}>
                                            Click to upload or drag and drop
                                        </p>
                                        <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--color-text-secondary)' }}>
                                            Maximum file size: 50 MB
                                        </p>
                                    </>
                                )}
                            </label>
                        </div>

                        {/* Upload Progress */}
                        {uploadProgress > 0 && uploadProgress < 100 && (
                            <div style={{ marginTop: '1rem' }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.85rem', color: 'var(--color-text-secondary)', marginBottom: '0.25rem' }}>
                                    <span>Uploading...</span>
                                    <span>{uploadProgress}%</span>
                                </div>
                                <div style={{ width: '100%', background: 'var(--color-border, #e5e7eb)', borderRadius: '9999px', height: '8px' }}>
                                    <div
                                        style={{
                                            width: `${uploadProgress}%`,
                                            height: '8px',
                                            borderRadius: '9999px',
                                            background: 'var(--color-primary, #2563eb)',
                                            transition: 'width 0.3s ease',
                                        }}
                                    />
                                </div>
                            </div>
                        )}

                        {/* Attachment list */}
                        {attachments.length > 0 ? (
                            <ul className="tf-attachment-list">
                                {attachments.map((attachment) => (
                                    <li key={attachment.id} className="tf-attachment-item">
                                        <span className="tf-attachment-file-icon">
                                            {getFileIcon(attachment.type)}
                                        </span>
                                        <div className="tf-attachment-info">
                                            <span className="tf-attachment-name">{attachment.name}</span>
                                            <span className="tf-attachment-meta">
                                                {formatBytes(attachment.size)} · {attachment.uploadedAt}
                                            </span>
                                        </div>
                                        <button
                                            type="button"
                                            className="tf-attachment-remove"
                                            onClick={() => removeAttachment(attachment.id)}
                                            aria-label={`Remove ${attachment.name}`}
                                        >
                                            <FiX size={14} />
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="tf-empty-msg">No attachments yet.</p>
                        )}

                    </div>
                </div>
            )}

            {activeTab === 'history' && (
                <div className="tf-tab-panel tf-history-panel">
                    <div className="tf-empty-state">
                        <p className="tf-empty-state-title bold text-center">No history found</p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UserVendorCreateContract;

